// extracted by mini-css-extract-plugin
export default {"items":"MFWc8_","search":"L7F9ox","subtitle":"tuGVnj"};